import { useState, useEffect, useRef } from 'react';
import { validateEmail, validateNumber } from '../../../Utils/Validation';
import { useTheme } from '../../../GlobalContext/GlobalContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { getData, postData } from '../../../ApiServices/ApiService';
import {
  ORG_GET_SERVICE_LIST, ORG_GET_SUB_SERVICE_LIST, ORG_GET_GROUP_LIST, ORG_GET_EMPLOYEE_LIST, ORG_GET_SUB_SERVICE_LIST_SEARCH,
  ORG_GET_SERVICE_LIST_SEARCH, ORG_GET_CLIENT_TO_DO_LIST_DD, ORG_GET_ALL_CODES_LIST, ORG_ADD_TASK, ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER,
  ORG_GET_CLIENT_INFO, ORG_ADD_DOCUMENT_RACK
} from '../../../ApiServices/BaseURL';
import { logFrontendException } from '../../../Utils/Exception';

const CreateTaskController = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [fileName, setFileName] = useState("");
  const [searchUser, setSearchUser] = useState('');
  const clintInfo = useRef(location.state?.clintInfo);
  const clientId = location.state?.clientId;
  const [infoLoading, setInfoLoading] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [uploadDocumentLoading, setUploadDocumentLoading] = useState(false);
  const [uploadDocumentError, setUploadDocumentError] = useState('');
  const { setIsLoginPopup } = useTheme();
  const [formData, setFormData] = useState({
    clientName: '', // Text input for Client Name
    services: {}, // Multiselect dropdown for Services
    taskCategory: {}, // Dropdown for Task Category
    group: '', // Dropdown for Group
    primaryAssignedUser: null, // Dropdown for Primary Assigned User
    taskLeader: null, // Dropdown for Task Leader
    taskManager: null, // Dropdown for Task Manager
    financialYear: {}, // Dropdown for Financial Year
    period: {}, // Text input for Period
    billAmount: '', // Text input for Bill Amount
    agreedBillAmount: '',
    fileNo: '', // Text input for File Number
    taskDescription: '', // Textarea for Task Description
    startDate: '', // Date Picker for Start Date
    dueDate: '', // Date Picker for Due Date
    taskPriority: { label: 'Not Priority', value: 0 }, // Dropdown for Task Priority
    toDoList: null, // Multiselect dropdown for To-Do List
    completedBy: '', // Dropdown for Completed By
    allowTimePosting: false, // Checkbox for Time Posting
    documents: null
  });

  const [clientList1, setClientList1] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [categoryList, setCategoryList] = useState([])
  const [groupList, setGroupList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [periodList, setPeriodList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);
  const [groupError, setGroupError] = useState(false);
  const [yearLoading, setYearLoading] = useState(false);
  const [yearError, setYearError] = useState('');
  const [serviceLoading, setServiceLoading] = useState(false);
  const [clientLoading, setClientLoading] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [billError, setBillError] = useState('');
  const [agreedBillError, setAgreedBillError] = useState('');
  const [clientNameError, setClientNameError] = useState('');
  const [serviceError, setServiceError] = useState('');
  const [taskCategoryError, setTaskCategoryError] = useState('');
  const [financialYearError, setFinancialYearError] = useState('');
  const [financialPeriodError, setFinancialPeriodError] = useState('');
  const [startDateError, setStartDateError] = useState('');
  const [dueDateError, setDueDateError] = useState('');
  const [employeeList, setEmployeeList] = useState([]);
  const [empLoading, setEmpLoading] = useState(false);
  const [empError, setEmpError] = useState('');
  const [taskAssignedError, setTaskAssignedError] = useState('');
  const [toDoList, setToDoList] = useState([])
  const [toDoLoading, setToDoLoading] = useState(false);
  const [toDoError, setToDoError] = useState('');

  const pageName = "CreateTaskController";
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

  useEffect(() => {
    const populateFormData = () => {
      setFormData((prev) => ({
        ...prev,
        clientName: clintInfo.current.client_name || '', // Populate Client Name
        group: clintInfo.current.group_name || '', // Populate Group Name
        primaryAssignedUser: clintInfo.current.emp_id_incharge_name || null, // Populate Primary Assigned User
        fileNo: clintInfo.current.client_file_id || '', // Populate File Number
        taskDescription: '', // Populate Task Description (example)
        startDate: '', // Populate Start Date
        taskLeader: null, // Add mapping if Task Leader is available
        taskManager: null, // Add mapping if Task Manager is available
        financialYear: {}, // Add mapping if Financial Year is available
        period: '', // Populate Period if applicable
        billAmount: '', // Add mapping if Bill Amount is available
        agreedBillAmount: '', // Add mapping if Agreed Bill Amount is available
        clientEmail: clintInfo.current.client_email || '',
        taskPriority: { label: 'Not Priority', value: 0 }, // Default Task Priority
        toDoList: { label: '', value: 0 }, // Add mapping if To-Do List is available
        completedBy: '', // Add mapping if Completed By is available
        allowTimePosting: false, // Default Checkbox
        documents: null, // Add mapping for Documents
      }));
      setSearchUser(clintInfo.current.client_name);
      setSelectedClient(clintInfo.current);
      fetchToDOList(clintInfo.current?.client_id)
    };
    if (clintInfo.current) {
      populateFormData();
    }
    else if (clientId) {
      fetchClientInfo();
    }
  }, [clintInfo.current, clientId]);


  useEffect(() => {
    setError("");
    fetchServiceList();
    fetchGroupList();
    fetchYearList();
    fetchUserList();
    setBillError("");
    setAgreedBillError("");
    setClientNameError("");
    setServiceError("");
    setTaskCategoryError("");
    setFinancialYearError("");
    setStartDateError("");
    setDueDateError("");
    setFinancialPeriodError("");
    setToDoError('');
  }, []);

  const fetchClientInfo = async () => {
    try {
      setInfoLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_CLIENT_INFO}?emp_id_auth=${storedUserInfo?.emp_id}&client_id=${clientId?.client_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              clintInfo.current = responseData?.dataJ[0];
            } else {
              setError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData?.info || '');
            }
          } else {
            setError(responseData?.info || 'Failed to fetch client data. Please try again.');
            logFrontendException(storedUserId, pageName, "handleUpdateToggle", responseData?.info || '');
          }
        } else {
          setError(responseData?.info || 'Failed to fetch client data.');
          logFrontendException(storedUserId, pageName, "handleUpdateToggle", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setError('Unauthorized access. Your session may have expired. Please log in again.');
         logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData || ''); 
        setIsLoginPopup(true)
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData || '');
      }
    } catch (error) {
       setError(`Failed to fetch client data. Please check your network connection and try again.`);
       logFrontendException(storedUserId, pageName, "fetchClientInfo-catch", error || '');
      
    } finally {
      setInfoLoading(false);
    }
  }

  const fetchServiceList = async () => {
    try {
      setServiceError('')
      setServiceLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id
      }

      // Make the API call
      // const response = await getData(`${ORG_GET_SERVICE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              // Transforming the data
              const serviceOptions = await responseData?.dataJ.map(service => ({
                label: service.service_name,
                value: service.service_id
              }));
              setServiceList(serviceOptions);
            } else {
              setServiceError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData?.info || '');
            }
          } else {
            setServiceError(responseData?.info || 'Failed to fetch data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData?.info || '');
          }
        } else {
          setServiceError(responseData?.info || 'Something went wrong while processing your request.');
          logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
          setServiceError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.'); 
          logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData || '');
      }
      
      else {
        setServiceError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchClientInfo", responseData || '');
      }
    } catch (error) {
     
        setServiceError(`Something went wrong while processing your request. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchClientInfo-catch", error || '');
      
    } finally {
      setServiceLoading(false);
    }
  }

  const fetchCategoryList = async (serviceId) => {
    try {
      setTaskCategoryError('')
      setCategoryList([])
      setCategoryLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "service_id": serviceId
      }
      //console.log('fetchTaskSubCategorieList payload', payLoad);
      // Make the API call
      // const response = await getData(`${ORG_GET_SUB_SERVICE_LIST}?service_id=${serviceId}&emp_id_auth=${storedUserInfo?.emp_id}`);
      const response = await postData(ORG_GET_SUB_SERVICE_LIST_SEARCH, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              // Transforming the data
              const serviceOptions = await responseData?.dataJ.map(service => ({
                label: service.service_sub_name,
                value: service.service_sub_id
              }));
              setCategoryList(serviceOptions);
            } else {
              setTaskCategoryError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchCategoryList", responseData?.info || '');
            }
          } else {
            setTaskCategoryError(responseData?.info || 'Failed to fetch data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchCategoryList", responseData?.info || '');
          }
        } else {
          setTaskCategoryError(responseData?.info || 'Something went wrong while processing your request.');
          logFrontendException(storedUserId, pageName, "fetchCategoryList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
          setTaskCategoryError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchCategoryList", responseData || '');
          setIsLoginPopup(true)
        
      }
     
      // Unexpected or network-related errors
      else {
        setTaskCategoryError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchCategoryList", responseData || '');
      }
    } catch (error) {
      // Handle various error scenarios
      
       
        setTaskCategoryError(`Something went wrong while processing your request. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchCategoryList-catch", error || '');
      
    } finally {
      setCategoryLoading(false);
    }
  }

  const fetchGroupList = async () => {
    try {
      setGroupLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              // Transforming the data
              const groupOptions = await responseData?.dataJ.map(service => ({
                label: service.group_name,
                value: service.group_id
              }));
              setGroupList(groupOptions);
            } else {
              setGroupError(responseData?.info || 'Data Not Found');   
            }
          } else {
            setGroupError(responseData?.info || 'Failed to fetch data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchGroupList", responseData?.info || '');
          }
        } else {
          setGroupError(responseData?.info || 'Something went wrong while processing your request.');
          logFrontendException(storedUserId, pageName, "fetchGroupList", responseData || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setGroupError('Unauthorized access. Your session may have expired. Please log in again.');
        logFrontendException(storedUserId, pageName, "fetchGroupList", responseData || '');
        setIsLoginPopup(true);
      }
      // Unexpected or network-related errors
      else {
        setGroupError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchGroupList", responseData || '');
      }
    } catch (error) {
      setGroupError(`Failed to fetch group list. Please check your network connection and try again.`);
      logFrontendException(storedUserId, pageName, "fetchGroupList-catch", error || '');
    } finally {
      setGroupLoading(false);
    }
  }


  const fetchYearList = async () => {
    try {
      setYearLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const payLoad = { "code_id": "org_all_codes" }
      const response = await postData(ORG_GET_ALL_CODES_LIST, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ) {
              // Transforming the data
              const yerarListOption = await responseData?.dataJ?.financial_year_codes_list.map(service => ({
                label: service.year_name,
                value: service.year_id
              }));

              setYearList(yerarListOption)
              // Transforming the data
              const periodOption = await responseData?.dataJ?.financial_period_codes_list.map(service => ({
                label: service.pc_name,
                value: service.pc_id
              }));
              setPeriodList(periodOption)
            } else {
              setYearError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchYearList", responseData?.info || '');
            }
          } else {
            setYearError(responseData?.info || 'Failed to fetch data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchYearList", responseData?.info || '');
          }
        } else {
          setYearError(responseData?.info || 'Something went wrong while processing your request.');
          logFrontendException(storedUserId, pageName, "fetchYearList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setYearError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
        logFrontendException(storedUserId, pageName, "fetchYearList", responseData || '');
        setIsLoginPopup(true)
      }
      // Internal Server Error: 500
      
      // Unexpected or network-related errors
      else {
        setYearError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchYearList", responseData || '');
      }
    } catch (error) {
      
        // An error occurred in setting up the request
        setYearError(`Something went wrong while processing your request. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchYearList-catch", error || '');
      
    } finally {
      setYearLoading(false);
    }
  }

  const fetchUserList = async () => {
    try {
      setEmpLoading(true);
      setEmpError('');
      setEmployeeList([]);


      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const filterData = responseData?.dataJ.map(service => ({
                label: service?.emp_name,
                value: service?.emp_id
              }));
              setEmployeeList(filterData);
            } else {
              setEmpError(responseData?.info || 'Data Not Found');
            }
          } else {
            setEmpError(responseData?.info || 'Failed to fetch User data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchUserList", responseData?.info || '');
          }
        } else {
          setEmpError(responseData?.info || 'Failed to fetch User data.');
          logFrontendException(storedUserId, pageName, "fetchUserList", responseData || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setEmpError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true);
      }
      // Unexpected or network-related errors
      else {
        setEmpError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchUserList", response || '');
      }
    } catch (error) {
      setEmpError(`Failed to fetch User data. Please check your network connection and try again.`);
      logFrontendException(storedUserId, pageName, "fetchUserList-catch", error || '');
    } finally {
      setEmpLoading(false);
    }
  }

  const fetchToDOList = async (clientId) => {
    try {
      setToDoError('')
      setToDoLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_CLIENT_TO_DO_LIST_DD}?emp_id_auth=${storedUserInfo?.emp_id}&emp_id=${storedUserInfo?.emp_id}&client_id=${clientId}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              // Transforming the data
              const toDoOptions = await responseData?.dataJ.map(service => ({
                label: service.sc_desc,
                value: service.sc_id
              }));
              setToDoList(toDoOptions);
            } else {
              setToDoError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchTodoList", responseData?.info || '');
            }
          } else {
            setToDoError(responseData?.info || 'Failed to fetch data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchTodoList", responseData?.info || '');
          }
        } else {
          setToDoError(responseData?.info || 'Something went wrong while processing your request.');
          logFrontendException(storedUserId, pageName, "fetchTodoList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setToDoError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchTodoList", responseData || '');
          setIsLoginPopup(true)
        
      }
      else {
        setToDoError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchTodoList", responseData || '');
      }
    } catch (error) {
     
        // An error occurred in setting up the request
        setToDoError(`Something went wrong while processing your request. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchTodoList-catch", error || '');
      
    } finally {
      setToDoLoading(false);
    }
  }


  const handleChange = (name, value) => {
    // const { name, value } = e.target;
    //console.log('name:----', name, 'value:-----', value)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === 'services' && { taskCategory: {} })
    }));

    if (name === 'services' && value) {
      fetchCategoryList(value.value);
    } else {
      //console.log('name not valid')
    }
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      documents: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name); // Set the selected file name
    }
  };

  const clearFeilds = () => {
    setFormData({
      clientName: '', // Text input for Client Name
      services: {}, // Multiselect dropdown for Services
      taskCategory: {}, // Dropdown for Task Category
      group: '', // Dropdown for Group
      primaryAssignedUser: null, // Dropdown for Primary Assigned User
      taskLeader: null, // Dropdown for Task Leader
      taskManager: null, // Dropdown for Task Manager
      financialYear: {}, // Dropdown for Financial Year
      period: {}, // Text input for Period
      billAmount: '', // Text input for Bill Amount
      agreedBillAmount: '',
      fileNo: '', // Text input for File Number
      taskDescription: '', // Textarea for Task Description
      startDate: '', // Date Picker for Start Date
      dueDate: '', // Date Picker for Due Date
      taskPriority: { label: 'Not Priority', value: 0 }, // Dropdown for Task Priority
      toDoList: null, // Multiselect dropdown for To-Do List
      completedBy: '', // Dropdown for Completed By
      allowTimePosting: false, // Checkbox for Time Posting
      documents: null
    });
    setSelectedClient(null);
    setSearchUser('');
  }

  const handleSubmit = async (e) => {
    console.log('handleSubmit:-')
    e.preventDefault();

    // Submit form data to your backend API
    //console.log('Form Data Submitted:', formData);
    try {
      setSuccess('')
      setError('');
      setBillError("");
      setAgreedBillError("");
      setClientNameError("");
      setServiceError("");
      setTaskCategoryError("");
      setFinancialYearError("");
      setStartDateError("");
      setDueDateError("");
      setFinancialPeriodError("");
      setTaskAssignedError("");
      setToDoError('');

      setLoading(true);

      if (!searchUser) {
        setClientNameError("Please select the client name")
        return false;
      }

      if (!formData.services?.value) {
        setServiceError("Please select the service")
        return;
      }

      if (!formData.taskCategory?.value) {
        setTaskCategoryError("Please select the task")
        return;
      }

      // if(!formData.primaryAssignedUser?.value){
      //   setTaskAssignedError("Please select the user")
      //   return;
      // }

      if (!formData.financialYear?.value) {
        setFinancialYearError("Please select the financial year")
        return;
      }

      if (!formData.period?.value) {
        setFinancialPeriodError("Please select the financial period")
        return;
      }

      if (!formData.startDate) {
        setStartDateError("Please select the start date")
        return;
      }

      if (!formData.dueDate) {
        setDueDateError("Please select the due date")
        return;
      }
      const startDateObj = new Date(formData.startDate);
      const endDateObj = new Date(formData.dueDate);
      // Validation: Start date should not be greater than the end date
      if (formData?.startDate && formData?.dueDate && startDateObj > endDateObj) {
        setError("Due date cannot be earlier than the start date."); return
      }

      // if (!validateNumber(formData.billAmount)) {
      //   setBillError("Invalid bill amount.");
      //   return false;
      // }

      // if (!validateNumber(formData.agreedBillAmount)) {
      //   setAgreedBillError("Invalid agreed bill amount.");
      //   return false;
      // }

      //console.log('before',formData?.toDoList)
      let valueArray = [];
      // Validation to ensure formData?.toDoList is an array and not null or undefined
      if (Array.isArray(formData?.toDoList) && formData?.toDoList.length > 0) {
        valueArray = formData.toDoList.map((item) => item.value);
      }
      //console.log('after',formData?.toDoList)
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "client_id": selectedClient?.client_id,
        "service_id": formData?.services?.value,
        "service_sub_id": formData?.taskCategory?.value,
        "task_description": formData?.taskDescription,
        "task_start_date": formData?.startDate,
        "task_due_date": formData?.dueDate,
        "task_priority": formData?.taskPriority?.value,
        "invoice_amt_agreed": formData?.agreedBillAmount || 0,
        "invoice_amt_estimated": formData?.billAmount || 0,
        "financial_year": formData?.financialYear?.value,
        "financial_period": formData?.period?.value,
        "employee_id_assigned": 0,
        "to_do_list_list": valueArray
      }

      //console.log('catagory Data', payLoad);
      // Make the API call
      const response = await postData(ORG_ADD_TASK, payLoad);
      const responseData = await response.json();
      //console.log('response Data12345', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setSuccess(responseData?.info);
            if(documentData){
              handleUploadDocument(responseData?.dataJ[0]);
            }
            clearFeilds();
            setTimeout(() => {
              setSuccess('')
              navigate(`/manage-clients`, { state: { task: 'Tasks', clientId: selectedClient?.client_id,  taskInfo:responseData?.dataJ[0] }}); // Pass task in state
            }, 3000);

          } else {
            setError(responseData?.info || 'Failed to fetch data. Please try again.');
            logFrontendException(storedUserId, pageName, "handleSubmit", responseData?.info || '');
          }
        } else {
          setError(responseData?.info || 'Something went wrong while processing your request.');
          logFrontendException(storedUserId, pageName, "handleSubmit", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
        logFrontendException(storedUserId, pageName, "handleSubmit", responseData || '');
        setIsLoginPopup(true)
      }
      
      else {
        setError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "handleSubmit", responseData || '');
      }
    } catch (error) {
        setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "handleSubmit-catch", error|| '');
      
    } finally {
      setLoading(false);
    }

  };

  const handleSelectClient = (client) => {
    setSelectedClient(client); // Set selected client data
    setSearchUser(client?.client_name); // Update TextInput with the selected client's name
    setClientList1([]); // Clear the dropdown
    setFormData((prevData) => ({
      ...prevData,
      group: client?.group_name,
      fileNo: client?.client_file_id
    }));
    fetchToDOList(client?.client_id)
  };

  const handleSearchClient = async () => {
    try {
      console.log('handleSearchClient')
      setClientNameError('');
      if (searchUser.trim().length <= 2) {
        setClientNameError('Min 3 letters required.'); return
      }
      setClientLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        emp_id_auth: storedUserInfo?.emp_id,
        search_type: "GENERIC",
        search_word: searchUser
      };

      //console.log('Searching Client with payload:', payLoad);

      // Make the API call
      const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
      const responseData = await response.json();
      //console.log('Search Client Response Data:', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setClientList1(responseData?.dataJ || []); // Update client list with fetched data
          } else {
            setClientNameError(responseData?.info || 'Failed to fetch Client. Please try again.');
            logFrontendException(storedUserId, pageName, "handleSearchClient", responseData?.info || '');
          }
        } else {
          setClientNameError(responseData?.info || 'Failed to fetch Client.');
          logFrontendException(storedUserId, pageName, "handleSearchClient", responseData?.info || '');
        }
      }
      // Handle token-related errors: 400, 401, 403
      else if ([400, 401, 403].includes(response?.status)) {
      
          setClientNameError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "handleSearchClient", response || '');
          setIsLoginPopup(true)
        
      }
     
      else {
        setClientNameError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "handleSearchClient", response || '');
      }
    } catch (error) {
      
        setClientNameError(`An error occurred. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "handleSearchClient-catch", error || '');
      
    } finally {
      setClientLoading(false);
    }
  };

  const handleUploadDocument = async (taskId) => {
    console.log("taskId",taskId);

    try {
      setError('');
      setUploadDocumentLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, client_id: clintInfo.current?.client_id || selectedClient?.client_id, doc_name: documentData?.finalDocumentName, doc_name_with_ext: `${documentData?.finalDocumentName}.${documentData?.fileExtension}`, doc_upload_via: documentData?.deliveryType, doc_description: documentData?.description, doc_base_64: documentData?.base64File, doc_is_internal: documentData?.documentType, doc_source_id: documentData?.source, doc_class: 'TASK', task_id: taskId?.task_id }

      console.log('handleadddocumentRack payload', payLoad);
      
      // Make the API call
      const response = await postData(ORG_ADD_DOCUMENT_RACK, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setUploadDocumentError('')
            // setEmployeeList(responseData?.dataJ || []);
            setSuccess(responseData?.info);
            clearFeilds();
            setTimeout(() => {
              // onValueChange();
            }, 3000);
          } else {
            setUploadDocumentError(responseData?.info || 'Failed to upload document. Please try again.');
            logFrontendException(storedUserId, pageName, "handleUploadDocument", responseData?.info || '');
          }
        } else {
          setUploadDocumentError(responseData?.info || 'Failed to upload document.');
          logFrontendException(storedUserId, pageName, "handleUploadDocument", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setUploadDocumentError(responseData?.info || 'Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "handleUploadDocument", responseData || '');
          setIsLoginPopup(true)
        
      }
     
      else {
        setUploadDocumentError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "handleUploadDocument", responseData || '');
      }
    } catch (error) {
      
        setUploadDocumentError(`Failed to upload document. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "handleUploadDocument-catch", error || '');
      
    } finally {
      setUploadDocumentLoading(false);
    }

    // onValueChange(teamData);
    // onClose();
  };

  const handleOpenDocumentModal = () => {
    setIsDocumentModalOpen(true);
  }

  const handleCloseDocumentModal = () => {
    setIsDocumentModalOpen(false);
  }

  const handleDocumentSubmit = (data) => {
    console.log("Received Data from Modal:", data);
    setDocumentData(data);
    setIsDocumentModalOpen(false);
  };

  // console.log("Document Data", documentData);

  const handleCancel = () => {
    setFormData({
      clientName: '',
      services: {},
      taskCategory: {},
      group: '',
      primaryAssignedUser: null,
      taskLeader: null,
      taskManager: null,
      financialYear: {},
      period: {},
      billAmount: '',
      agreedBillAmount: '',
      fileNo: '',
      taskDescription: '',
      startDate: '',
      dueDate: '',
      taskPriority: { label: 'Not Priority', value: 0 },
      toDoList: null,
      completedBy: '',
      allowTimePosting: false,
      documents: null
    });
    setSelectedClient(null);
    setSearchUser('');
    setDocumentData(null);
    navigate(`/dashboard`);
  };


  return {
    formData,
    fileName,
    handleFileChange,
    handleSubmit,
    handleChange,
    serviceList,
    categoryList,
    groupList,
    yearList,
    periodList,
    error,
    loading,
    billError,
    agreedBillError,
    clientNameError,
    serviceError,
    taskCategoryError,
    financialYearError,
    startDateError,
    dueDateError,
    financialPeriodError,
    handleSearchClient,
    searchUser,
    setSearchUser,
    clientList1,
    setClientList1,
    handleSelectClient,
    selectedClient,
    setSelectedClient,
    clientLoading,
    categoryLoading,
    employeeList,
    empLoading,
    empError,
    groupLoading,
    yearLoading,
    serviceLoading,
    taskAssignedError,
    yearError,
    groupError, success,
    toDoList, toDoError, toDoLoading,
    infoLoading,
    isDocumentModalOpen,
    handleCloseDocumentModal,
    handleOpenDocumentModal,
    handleDocumentSubmit,
    clintInfo,
    documentData,
    handleCancel
  };
};

export default CreateTaskController;
